import { useState, useEffect, useCallback } from 'react';
import { bffQuery, bffMutation } from '@parsina/framework/clinical/src/lib/bffClient';

const TEMPLATES_QUERY = `
  query {
    noteTemplates {
      id
      title
      tag
      tagColor
      content
    }
    prescriptionTemplates {
      id
      title
      content
    }
  }
`;

const ADD_NOTE = `
  mutation($input: NoteTemplateInput!) {
    addNoteTemplate(input: $input) { id title tag tagColor content }
  }
`;

const UPDATE_NOTE = `
  mutation($id: ID!, $input: NoteTemplateInput!) {
    updateNoteTemplate(id: $id, input: $input) { id title tag tagColor content }
  }
`;

const DELETE_NOTE = `
  mutation($id: ID!) { deleteNoteTemplate(id: $id) }
`;

const ADD_RX = `
  mutation($input: PrescriptionTemplateInput!) {
    addPrescriptionTemplate(input: $input) { id title content }
  }
`;

const UPDATE_RX = `
  mutation($id: ID!, $input: PrescriptionTemplateInput!) {
    updatePrescriptionTemplate(id: $id, input: $input) { id title content }
  }
`;

const DELETE_RX = `
  mutation($id: ID!) { deletePrescriptionTemplate(id: $id) }
`;

export function useTemplates() {
  const [noteTemplates, setNoteTemplates] = useState([]);
  const [prescriptionTemplates, setPrescriptionTemplates] = useState([]);
  const [loading, setLoading] = useState(true);

  const reload = useCallback(() => {
    setLoading(true);
    bffQuery(TEMPLATES_QUERY)
      .then(data => {
        setNoteTemplates(data.noteTemplates);
        setPrescriptionTemplates(data.prescriptionTemplates);
      })
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => { reload(); }, [reload]);

  const addNote    = (input)      => bffMutation(ADD_NOTE,    { input }).then(reload);
  const updateNote = (id, input)  => bffMutation(UPDATE_NOTE, { id, input }).then(reload);
  const deleteNote = (id)         => bffMutation(DELETE_NOTE, { id }).then(reload);
  const addRx      = (input)      => bffMutation(ADD_RX,      { input }).then(reload);
  const updateRx   = (id, input)  => bffMutation(UPDATE_RX,   { id, input }).then(reload);
  const deleteRx   = (id)         => bffMutation(DELETE_RX,   { id }).then(reload);

  return {
    noteTemplates, prescriptionTemplates, loading,
    addNote, updateNote, deleteNote,
    addRx, updateRx, deleteRx,
  };
}
